/**
 * Keyboard input → integer minor units, by string handling only. This is parsing what the user typed, not arithmetic:
 * "1234.5" becomes the digits "123450" and one `Number()`. Totals, tax and discounts are never computed here (R5).
 */
export const fractionDigitsOf = (currency: string, locale: string) =>
  new Intl.NumberFormat(locale, { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;

/** `"1,234.50"` → `123450` (INR); null when empty, not a number, zero, or has more decimals than the currency. */
export function parseMoneyInput(raw: string, digits: number): number | null {
  const s = raw.replace(/[,\s]/g, "");
  const m = /^(\d+)(?:\.(\d*))?$/.exec(s);
  if (!m) return null;
  const frac = m[2] ?? "";
  if (frac.length > digits) return null;
  const minor = Number(`${m[1]}${frac.padEnd(digits, "0")}`);
  return Number.isSafeInteger(minor) && minor > 0 ? minor : null;
}

/** `"12.5"` percent → `1250` basis points; null when not a number with at most 2 decimals, or outside 0.01–100. */
export function parsePercentToBp(raw: string): number | null {
  const m = /^(\d{1,3})(?:\.(\d{0,2}))?$/.exec(raw.trim());
  if (!m) return null;
  const bp = Number(`${m[1]}${(m[2] ?? "").padEnd(2, "0")}`);
  return bp >= 1 && bp <= 10_000 ? bp : null;
}
